module.exports = [{"label":"Workflow","ico":"split","data":[{"id":"scrum","label":"Scrum","level":90},{"id":"lean","label":"Lean Frontend","level":100},{"id":"code-review","label":"Code Review","level":100},{"id":"beer","label":"After Work Beers","level":100}]},{"label":"Tools","ico":"organization","data":[{"id":"vcs","label":"Git","level":100},{"id":"svn","label":"SVN","level":100},{"id":"github","label":"Github / Bitbucket","level":100},{"id":"jenkins","label":"Jenkins","level":80},{"id":"trello","label":"Trello","level":100},{"id":"docker","label":"Docker","level":80}]}]


//////////////////
// WEBPACK FOOTER
// ./app/assets/js/database/skills.team.json
// module id = iym1
// module chunks = 2